import { Component } from '@angular/core';
import { BsTimepickerViewComponent } from './bs-timepicker-view.component';
import { BsCurrentDateViewComponent } from './bs-current-date-view.component';


@Component({
    selector: 'bs-calendar-layout',
    template: `
    <!-- current date, will be added in nearest releases -->
    @if (false) {
      <bs-current-date title="hey there"></bs-current-date>
    }
    
    <!--navigation-->
    <div class="bs-datepicker-head">
      <ng-content select="bs-datepicker-navigation-view"></ng-content>
    </div>
    
    <div class="bs-datepicker-body">
      <ng-content></ng-content>
    </div>
    
    <!--timepicker-->
    @if (false) {
      <bs-timepicker></bs-timepicker>
    }
    `,
    standalone: true,
    imports: [BsCurrentDateViewComponent, BsTimepickerViewComponent]
})
export class BsCalendarLayoutComponent {}
